import React from 'react';

import flipImageXOperation from 'editor/src/store/design/operation/flipImageXOperation';
import getSelectedMediaElementsObjects from 'editor/src/store/design/selector/getSelectedMediaElementsObjects';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import IconFlipX from 'editor/src/component/Icon/IconFlipX';
import { CanShow, MenuItemProps } from 'editor/src/component/Menu/type';

import MenuButton from './MenuButton';

export const canShow: CanShow = (state, { hasSelection, isElementEmpty }) => {
  const { imageFlip } = state.hostSettings.coreFeatures;
  return !isElementEmpty && hasSelection && imageFlip;
};

type Props = Pick<MenuItemProps, 'context' | 'mode'>;

function ButtonFlipX({ context, mode }: Props) {
  const active = useSelector((state) => {
    const element = getSelectedMediaElementsObjects(state)[0];
    if (element && (element.type === 'image' || element.type === 'addon')) {
      return element.flipX;
    }
    return false;
  });
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(saveUndoRedoStateOperation('Flip X'));
    dispatch(flipImageXOperation(context.structureIndexes[0]));
  };

  return (
    <MenuButton
      Icon={IconFlipX}
      mode={mode}
      on={active}
      handleClick={handleClick}
      i18nKey="editor-flip-x-shortened"
      className="cy-button-flip-x"
    />
  );
}

export default React.memo(ButtonFlipX);
